import * as React from 'react';

import type { UserExperienceMembershipsQueryQuery } from 'bundles/unified-common/queries/__generated__/UserExperienceMembershipsQuery';

/** Program membership edge from user experience memberships query; exported for org-scoped context reuse. */
export type ProgramMembershipEdge = NonNullable<
  NonNullable<
    NonNullable<
      UserExperienceMembershipsQueryQuery['ProgramMemberships']
    >['queryProgramMembershipsByUserIdAndIncludeInvitations']
  >['edges']
>[number];

/** Degree membership element from user experience memberships query; exported for redirect utils. */
export type DegreeMembershipElement = NonNullable<
  NonNullable<
    NonNullable<
      NonNullable<UserExperienceMembershipsQueryQuery['NaptimeQueries']>['DegreeLearnerMembershipsV1Resource']
    >['byUser']
  >['elements']
>[number];

export type UserExperienceMembershipsContextType = {
  programMemberships?: ProgramMembershipEdge[];
  degreeMemberships?: DegreeMembershipElement[];
  isLoading: boolean;
  /** True when the memberships query failed; redirect logic should not redirect away from enterprise/degree pages. */
  isError?: boolean;
};

const UserExperienceMembershipsContext = React.createContext<UserExperienceMembershipsContextType | undefined>(
  undefined
);

const defaultMembershipsValue: UserExperienceMembershipsContextType = {
  programMemberships: [],
  degreeMemberships: [],
  isLoading: false,
};

export const useUserExperienceMemberships = () => {
  const context = React.useContext(UserExperienceMembershipsContext);
  if (context === undefined) {
    return defaultMembershipsValue;
  }
  return context;
};

export default UserExperienceMembershipsContext;
